import React, {useContext, useState} from 'react';
import ErrorPage from "./ErrorPage";
import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import {changeActivity, createUser, usersWithoutUser} from "../apis/userApi";
import {LanguageContext} from "../components/LanguageContext";
import {useDataGridLocaleText} from "../utils/dataGridLocale";
import Grid from "@mui/material/Grid2";
import {
    Alert,
    Box,
    Button,
    CircularProgress, Dialog,
    DialogActions,
    DialogContent,
    DialogTitle, FormControl, InputLabel, LinearProgress, MenuItem,
    Paper, Select,
    TextField,
    Typography
} from "@mui/material";
import GroupTwoToneIcon from '@mui/icons-material/GroupTwoTone';
import AddBoxTwoToneIcon from "@mui/icons-material/AddBoxTwoTone";
import Notification from "../components/Notification";
import {DataGrid} from "@mui/x-data-grid";
import IconButton from "@mui/material/IconButton";
import PowerSettingsNewTwoToneIcon from '@mui/icons-material/PowerSettingsNewTwoTone';
const AddUserPage = () => {
    const queryClient = useQueryClient();
    const {translations} = useContext(LanguageContext);
    const dgLocale = useDataGridLocaleText();
    const role_id = localStorage.getItem("role_id");
    const user_id = localStorage.getItem("user_id");

    const [formData, setFormData] = useState({
        ime: "",
        email: "",
        uloga: -1,
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (formData.ime === "") {
            setType(2);
            setMessage(translations.usersErrorNameEmpty);
            setOpenN(true);
            return;
        }

        if (formData.email === "") {
            setType(2);
            setMessage(translations.usersErrorEmailEmpty);
            setOpenN(true);
            return;
        }

        if (!/\S+@\S+\.\S+/.test(formData.email)) {
            setType(2);
            setMessage(translations.usersErrorEmailInvalid);
            setOpenN(true);
            return;
        }

        if (formData.uloga === -1) {
            setType(2);
            setMessage(translations.usersErrorRoleRequired);
            setOpenN(true);
            return;
        }
        setLoading(true);
        mutation.mutateAsync(formData).catch((err) => {});
    };

    const handleChangeActivity = (e, id) => {
        e.preventDefault();

        if (String(role_id) !== "1") {
            return;
        }

        const data = new FormData();

        data.append('id', id);
        mutationActivity.mutateAsync(data).catch((err) => {});
    }

    const [loading, setLoading] = useState(false);

    const [type, setType] = useState(null);
    const [openN, setOpenN] = useState(false);
    const [message, setMessage] = useState("");

    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    }

    const {data, isLoading, isError} = useQuery({
        queryKey: ['usersWithoutUser', user_id],
        queryFn: () => usersWithoutUser(user_id),
        enabled: String(role_id) === "1"
    });

    const mutation = useMutation({
        mutationFn: (formData) => createUser(formData),
        onSuccess: (response) => {
            setType(1);
            setMessage(response.data.message);
            setOpenN(true);
            setFormData({ ime: '', email: '', uloga: '' });
            handleClose();
            setLoading(false);

            queryClient.invalidateQueries(['usersWithoutUser', user_id]).then((res) => console.log(res));
        },
        onError: (error) => {
            setType(2);
            setMessage(error.response.data.message);
            setOpenN(true);
            setLoading(false);
        }
    });

    const mutationActivity = useMutation({
        mutationFn: (formData) => changeActivity(formData),
        onSuccess: (response) => {
            setType(1);
            setMessage(response.data.message);
            setOpenN(true);

            queryClient.invalidateQueries(['usersWithoutUser', user_id]).then((res) => console.log(res));
        },
        onError: (error) => {
            setType(2);
            setMessage(error.response.data.message);
            setOpenN(true);
        }
    })

    const columns = [
        {
            field: "id",
            headerName: translations.calcId,
            minWidth: 50,
            headerAlign: "center",
            align: "center",
        },

        {
            field: "ime",
            headerName: translations.usersName,
            minWidth: 150,
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        {
            field: "email",
            headerName: translations.usersEmail,
            minWidth: 150,
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        {
            field: "uloga",
            headerName: translations.usersRole,
            minWidth: 150,
            flex: 1,
            headerAlign: "center",
            align: "center",
            renderCell: (params) => {
                return <span>{Number(params.row.uloga) === 1 ? translations.usersRoleSuperuser : translations.usersRoleUser}</span>
            }
        },
        {
            field: "aktivnost",
            headerName: translations.usersActivity,
            minWidth: 150,
            flex: 1,
            headerAlign: "center",
            align: "center",
            renderCell: (params) => {
                return <span style={{color: Number(params.row.aktivnost) === 1 ? "green" : "red"}}>{Number(params.row.aktivnost) === 1 ? translations.usersActive : translations.usersDeactivated}</span>
            }
        },
        {
            field: "deactivate",
            headerName: translations.usersDeactivate,
            minWidth: 150,
            flex: 1,
            headerAlign: "center",
            align: "center",
            sortable: false,
            filterable: false,
            renderCell: (params) => {
                return (
                    <IconButton
                        onClick={(event) => handleChangeActivity(event, params.row.id)}
                        color={Number(params.row.aktivnost) === 1 ? "error" : "success"}
                        disabled={Number(params.row.uloga) === 1}
                        aria-label="delete"
                    >
                        <PowerSettingsNewTwoToneIcon />
                    </IconButton>
                );
            }
        },
    ];

    if (String(role_id) === "1") {
        return (
            <Grid container spacing={2}>
                <Notification
                    type={type}
                    message={message}
                    open={openN}
                    setOpen={setOpenN}
                />
                <Grid size={{xs: 12}}>
                    <Paper sx={{p: 2, justifyContent: "center", alignItems: "center"}}>
                        <Typography sx={{fontSize: 22, textAlign: "center"}}>
                            <GroupTwoToneIcon size={22} sx={{mr: 2}}/>
                            {translations.usersOtherUsers}
                        </Typography>
                    </Paper>
                </Grid>
                <Grid size={{xs: 12}}>
                    <Paper sx={{p: 2, justifyContent: "center", alignItems: "center"}}>
                        <Button
                            type="button"
                            fullWidth
                            variant="contained"
                            endIcon={loading ? null : <AddBoxTwoToneIcon/>}
                            onClick={handleClickOpen}
                            disabled={loading}
                        >
                            {loading ? <CircularProgress size={25} color="inherit"/> : translations.usersCreateNew}
                        </Button>
                    </Paper>
                </Grid>
                <Grid size={{xs: 12}}>
                    <Paper sx={{p: 2, justifyContent: "center", alignItems: "center", height: 600}}>
                        {isError ? (
                            <Alert severity="error">
                                {translations.usersErrorLoad}
                            </Alert>
                        ) : isLoading ? (
                            <LinearProgress size={24} color="inherit"/>
                        ) : (
                            <DataGrid
                                columns={columns}
                                rows={isLoading ? [] : data?.data}
                                localeText={dgLocale}
                            />
                        )}
                    </Paper>
                </Grid>

                <Dialog
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {translations.usersDialogTitle}
                    </DialogTitle>
                    <DialogContent>
                        <Box component="form" noValidate onSubmit={handleSubmit}>
                            <TextField
                                fullWidth
                                margin="dense"
                                label={translations.usersName}
                                placeholder={translations.usersNamePlaceholder}
                                name="ime"
                                value={formData.ime}
                                onChange={handleChange}
                                required
                            />
                            <TextField
                                fullWidth
                                margin="dense"
                                label={translations.usersEmail}
                                name="email"
                                type="email"
                                placeholder={translations.usersEmailPlaceholder}
                                value={formData.email}
                                onChange={handleChange}
                                required
                            />
                            <FormControl margin="dense" fullWidth required>
                                <InputLabel id="role-label">{translations.usersRole}</InputLabel>
                                <Select
                                    labelId="role-label"
                                    id="uloga"
                                    name="uloga"
                                    placeholder={translations.usersChooseRole}
                                    label={translations.usersRole}
                                    value={formData.uloga}
                                    onChange={handleChange}
                                    variant="outlined"
                                >
                                    <MenuItem value={-1} disabled={true}>{translations.usersChooseRoleBelow}</MenuItem>
                                    <MenuItem value={1}>{translations.usersRoleSuperuser}</MenuItem>
                                    <MenuItem value={2}>{translations.usersRoleUser}</MenuItem>
                                </Select>
                            </FormControl>
                            <DialogActions>
                                <Button onClick={handleClose} color="error">{translations.cancel}</Button>
                                <Button type="submit" variant="contained" color="success" onClick={handleClose}>
                                    {translations.confirm}
                                </Button>
                            </DialogActions>
                        </Box>
                    </DialogContent>
                </Dialog>
            </Grid>
        );
    } else {
        return (
            <ErrorPage errorCode={401} errorMessage={translations.unauthorized} homeLink={'/home'}/>
        );
    }
};

export default AddUserPage;